import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api';

export const getUserInfo = createAsyncThunk(
  'userInfo',
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const { company_id, admin } = await api.user().get();
        const user = await api.auth().getUser();
        const company = await api.company().get(company_id);

        if (user && company_id) resolve({ ...user.attributes, company_id, admin, company });
        reject();
      } catch (error) {
        reject(error);
      }
    })
);

export const updateUserInfo = createAsyncThunk('update/updateUserInfo', async ({ user, obj }) => {
  await api.user().update(user, obj);

  return { ...obj }
})

const userInfoSlice = createSlice({
  name: 'userInfo',
  /**
   * @type {User}
   */
  initialState: {
    user: null,
    loading: true,
    error: false
  },
  reducers: {
    clearUserInfo: (state, _action) => {
      state.user = null;
      state.error = false;
    },
    updateCompany: (state, { payload }) => {
      state.user = payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserInfo.pending, (state, _action) => {
        state.loading = true;
      })
      .addCase(getUserInfo.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.error = false;
      })
      .addCase(getUserInfo.rejected, (state, _action) => {
        console.log('Error when get user info...');
        state.user = null;
        state.loading = false;
        state.error = true;
      })
      .addCase(updateUserInfo.pending, (state, _action) => {
        state.loading = true;
      })
      .addCase(updateUserInfo.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.user = payload;
        state.error = false;
      })
      .addCase(updateUserInfo.rejected, (state, _action) => {
        state.error = true
        state.loading = false
      })
  }
});

export const { clearUserInfo, updateCompany } = userInfoSlice.actions;

/**
 *
 * @param {StateUser} state
 * @returns {StateUser}
 */
export const selectUserInfo = (state) => state.userInfo;

export default userInfoSlice.reducer;
